import { Formik } from "formik";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import * as Yup from "yup";

import {
  Button,
  Alert as MuiAlert,
  TextField as MuiTextField,
  Stack,
} from "@mui/material";
import { spacing } from "@mui/system";

import useAuth from "../../hooks/useAuth";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function SignIn() {
  const navigate = useNavigate();
  const { signIn } = useAuth();

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          await signIn(values.email, values.password);
          navigate("/");
        } catch (error) {
          const message =
            error?.response?.data?.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={3} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            size="small"
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <TextField
            type="password"
            name="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            size="small"
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <Button
            type="submit"
            fullWidth
            size="small"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            sx={{ mt: 2, mb: 2 }}
          >
            Sign in
          </Button>
          <Stack direction={{ xs: "column", md: "row" }} gap={3}>
            {/* <Button
              variant="outlined"
              component={Link}
              to="/auth/change-password"
              fullWidth
              size="small"
              color="primary"
            >
              Change password
            </Button> */}
            <Button
              variant="outlined"
              component={Link}
              to="/auth/forgot-password"
              fullWidth
              size="small"
              color="primary"
            >
              Forgot password
            </Button>
          </Stack>
        </form>
      )}
    </Formik>
  );
}

export default SignIn;
